import {Dropdown, SupportedLanguageCode} from '../dropdown-options';
import {TextTranslations} from '../question/utils';

export const convertJobCategoriesToDropdownOptions = () => {
  const options = {
    en: [] as Dropdown<number>[],
    fr: [] as Dropdown<number>[],
  };

  Object.entries(JOB_CATEGORY_ID_TO_DESCRIPTION).forEach(([id, translations]) => {
    const jobCategoryId = parseInt(id, 10);

    options.en.push({
      name: translations.en,
      value: jobCategoryId,
    });
    options.fr.push({
      name: translations.fr,
      value: jobCategoryId,
    });
  });

  options.en.sort((a, b) => a.name.localeCompare(b.name));
  options.fr.sort((a, b) => a.name.localeCompare(b.name));

  return options;
};

export function getJobCategoryDescription(jobCategoryId: number, language: SupportedLanguageCode): string {
  const description = JOB_CATEGORY_ID_TO_DESCRIPTION[jobCategoryId][language];
  if (!description) {
    throw new Error(`No description found for job category ID ${jobCategoryId} in language ${language}`);
  }
  return description;
}

export const JOB_CATEGORY_ID_TO_DESCRIPTION: Record<number, TextTranslations> = {
  1: {en: 'Props Person', fr: 'Accessoiriste'},
  2: {en: 'Piano Tuner', fr: 'Accordeur piano, accordeuse de piano'},
  3: {
    en: 'Maple Syrup Producer – Chainsaw Usage Less than 20%',
    fr: 'Acériculteur moins de 20 % utilisation scie à chaine, Acéricultrice moins de 20 % utilisation scie à chaine',
  },
  4: {
    en: 'Maple Syrup Producer – Chainsaw Usage 20% or More',
    fr: 'Acériculteur 20 % et plus utilisation scie à chaine, Acéricultrice 20 % et plus utilisation scie à chaine',
  },
  5: {en: 'Scrap Buyer', fr: 'Acheteur, ferraille, acheteuse ferraille'},
  6: {
    en: 'Outside General Merchandise Buyer',
    fr: 'Acheteur marchandises diverses extérieur du bureau, Acheteuse marchandises diverses extérieur du bureau',
  },
  7: {
    en: 'Inside General Merchandise',
    fr: 'Acheteur marchandises diverses bureau, Acheteuse marchandises diverses bureau',
  },
  8: {en: 'Acrobat', fr: 'Acrobate'},
  9: {en: 'Actor, Actress', fr: 'Acteur, Actrice'},
  10: {en: 'Actuary', fr: 'Actuaire'},
  11: {en: 'Acupuncturist', fr: 'Acupuncteur, Acupuncteure, Acupunctrice'},
  12: {en: 'Administrative Assistant', fr: 'Adjoint administratif, Adjointe administrative'},
  13: {en: 'Sales Assistant', fr: 'Adjoint, Adjointe aux ventes'},
  14: {en: 'Saw Filer/Saw Sharpener', fr: 'Affûteur, Affûteuse de scie'},
  15: {en: 'Customs Agent', fr: 'Agent, Agente douane, douane, Douanier, Douanière'},
  16: {en: 'Advertising and Marketing Agent', fr: 'Agent, Agente publicitaire, marketing, publicitaire'},
  17: {
    en: 'Securities Agent – Not on the Stock Exchange',
    fr: 'Agent, Agente, valeurs mobilières (pas à la bourse)',
  },
  18: {en: 'Travel Agent', fr: 'Agent, Agente, voyage'},
  19: {en: 'Placement Officer', fr: 'Agent, Agente,  de placement'},
  20: {en: 'Mortgage Agent', fr: 'Agent, Agente,  hypothécaire'},
  21: {en: 'Parole Officer', fr: 'Agent, Agente,  libération, Agent, Agente,  probation'},
  22: {en: 'Securities Agent – On the Stock Exchange', fr: 'Agent, Agente,  valeurs mobilières à la bourse'},
  23: {en: 'Union Agent, Union Representative', fr: 'Agent, Agente, Représentant, Représentante syndical'},
  24: {en: 'Security Officer – Unarmed', fr: 'Agent, Agente,  sécurité (non armé)'},
  25: {en: 'Security Officer – Armed', fr: 'Agent, Agente sécurité (armé)'},
  26: {en: 'Flight Attendant (see exclusions)', fr: 'Agent, Agente,  de bord (voir exclusions)'},
  27: {en: 'Collection Agent', fr: 'Agent, Agente,  recouvrement'},
  28: {
    en: 'Farmer and Owner – Supervision Work Only',
    fr: 'Agriculteur propriétaire, Agricultrice propriétaire avec supervision de travail seulement',
  },
  29: {
    en: 'Farmer and Owner – With Manual Labour',
    fr: 'Agriculteur propriétaire, Agricultrice propriétaire avec travail manuel',
  },
  30: {en: 'Farmer – Non-Owner', fr: 'Agriculteur, Agricultrice non propriétaire'},
  31: {en: 'Agronomist', fr: 'Agronome'},
  32: {en: 'Assistant Cook', fr: 'Aide–cuisinier, Aide–cuisinière'},
  33: {
    en: 'Licensed Child Care Educator Assistant – Outside of the Home with Administrative Work Only',
    fr: "Aide–éducateur, Aide–éducatrice garderie avec certificat à l'extérieur du domicile avec travail administratif seulement",
  },
  34: {
    en: 'Licensed Child Care Educator Assistant – Outside of the Home',
    fr: "Aide–éducateur, Aide–éducatrice garderie avec certificat à l'extérieur du domicile",
  },
  35: {
    en: 'Home Child Care Educator Assistant – Not Licensed',
    fr: 'Aide–éducateur, Aide–éducatrice garderie sans certification ou à domicile',
  },
  36: {en: 'Pharmacist Assistant', fr: 'Aide–pharmacien, Aide–pharmacienne'},
  37: {en: 'Diver Assistant', fr: 'Aide Plongeur, Plongeuse, Aide plongeuse'},
  38: {en: 'Switchman/Pointman', fr: 'Aiguilleur, Aiguilleuse'},
  39: {en: 'Fitter', fr: 'Ajusteur, Ajusteuse'},
  40: {en: 'Paramedic', fr: 'Ambulancier, ambulancière'},
  41: {en: 'Computer Analyst', fr: 'Analyste informatique'},
  42: {
    en: 'Laboratory Analyst  With No Exposure to Nuclear Radiation',
    fr: 'Analyste laboratoire non exposé aux émanations nucléaires',
  },
  43: {
    en: 'Laboratory Analyst  With Exposure to Nuclear Radiation',
    fr: 'Analyste laboratoire exposé aux émanations nucléaires',
  },
  44: {en: 'Anesthesiologist', fr: 'Anesthésiste'},
  45: {en: 'Domestic Animal Care Worker', fr: "Animalier, Animalière d'animaux domestiques"},
  46: {en: 'Bingo Facilitator', fr: 'Animateur, Animatrice de bingo'},
  47: {en: 'Radio Announcer', fr: 'Annonceur, Annonceuse à la radio'},
  48: {en: 'Television Announcer', fr: 'Annonceur, Annonceuse à la télévision'},
  49: {en: 'Antique Dealer – Seller Only', fr: 'Antiquaire Vendeur, Vendeuse (seulement)'},
  50: {en: 'Antique Dealer – Other', fr: 'Antiquaire autres'},
  51: {en: 'Beekeeper', fr: 'Apiculteur, Apicultrice'},
  52: {en: 'Sports Referee', fr: 'Arbitre sportif'},
  53: {en: 'Arborist', fr: 'Arboriculteur, Arboricultrice'},
  54: {en: 'Archaeologist – Not in the Field', fr: 'Archéologue pas sur le terrain'},
  55: {en: 'Archaeologist – In the Field', fr: 'Archéologue sur le terrain'},
  56: {en: 'Architect', fr: 'Architecte'},
  57: {en: 'Landscape Architect', fr: 'Architecte paysagiste'},
  58: {en: 'Archivist', fr: 'Archiviste'},
  59: {en: 'Armourer', fr: 'Armurier, Armurière'},
  60: {en: 'Environmental Surveyor', fr: 'Arpenteur, Arpenteuse environnementaliste'},
  61: {en: 'Land Surveyor', fr: 'Arpenteur, Arpenteuse géomètre'},
  62: {en: 'Urban Surveyor', fr: 'Arpenteur, Arpenteuse urbananiste'},
  63: {
    en: 'Survey Technician',
    fr: 'Arpenteur Technicien, Technicienne, Arpenteuse Technicien, Techniciennene',
  },
  64: {en: 'Potter (Potery Makery)', fr: 'Artisan, Artisane poterie'},
  65: {en: 'Ceramic Artist', fr: 'Artisan, Artisane céramique'},
  66: {en: 'Stained Glass Artist', fr: 'Artisan, Artisane vitrail'},
  67: {en: 'Weaver', fr: 'Artisan, Artisane tissage'},
  68: {
    en: 'Structural Steel Assembler – In a Factory',
    fr: 'Assembleur, Assembleuse charpente métallique en manufacture',
  },
  69: {en: 'Assembler (Other)', fr: 'Assembleur, Assembleuse autres'},
  70: {
    en: 'Structural Steel Assembler –Not in a Factory',
    fr: 'Assembleur, Assembleuse charpente métallique pas en manufacture',
  },
  71: {en: 'Dental Assistant', fr: 'Assistant, Assistante dentaire'},
  72: {en: 'Podiatrist Assistant', fr: 'Assistant, Assistante–podiatre'},
  73: {en: 'Veterinary Assistant', fr: 'Assistant, Assistante–vétérinaire'},
  74: {en: 'Pharmacy Assistant', fr: 'Assistant–pharmacien, Assistante–pharmacienne'},
  75: {
    en: 'Professional Athlete (see exclusions)',
    fr: 'Athlète professionnel (voir exclusions), Athlète professionnelle (voir exclusions)',
  },
  76: {en: 'Dog Catcher', fr: 'Attrapeur, Attrapeuse de chiens'},
  77: {en: 'Chicken Catcher', fr: 'Attrapeur, Attrapeuse de poulets'},
  78: {en: 'Audiologist', fr: 'Audiologiste'},
  79: {en: 'Hearing Aid Practitioner', fr: 'Audioprothésiste'},
  80: {en: 'Chaplain', fr: 'Aumônier, Aumônière'},
  81: {en: 'Author', fr: 'Auteur, Auteure'},
  82: {en: 'Lawyer', fr: 'Avocat, Avocate'},
  83: {en: 'Bacteriologist – No Laboratory Work', fr: 'Bactériologiste aucun travail en laboratoire'},
  84: {
    en: 'Bacteriologist – Laboratory With No Exposure to Nuclear Radiation',
    fr: 'Bactériologiste laboratoire non exposé aux émanations nucléaires',
  },
  85: {
    en: 'Bacteriologist – Laboratory With Exposure to Nuclear Radiation',
    fr: 'Bactériologiste laboratoire exposé aux émanations nucléaires',
  },
  86: {en: 'Barber', fr: 'Barbier, Barbière'},
  87: {en: 'Bartender – Strip Club', fr: 'Barmaid, barman dans les bars de danseurs ou danseuses nues'},
  88: {en: 'Bartender – Other', fr: 'Barmaid, barman autres'},
  89: {en: 'Librarian', fr: 'Bibliothécaire'},
  90: {en: 'Biologist – No Laboratory Work', fr: 'Biologiste aucun travail en laboratoire'},
  91: {
    en: 'Biologist – Laboratory With No Exposure to Nuclear Radiation',
    fr: 'Biologiste laboratoire non exposé aux émanations nucléaires',
  },
  92: {
    en: 'Biologist – Laboratory With Exposure to Nuclear Radiation',
    fr: 'Biologiste laboratoire exposé aux émanations nucléaires',
  },
  93: {en: 'Laundry Worker', fr: 'Blanchisseur, Blanchisseuse'},
  94: {en: 'Botanist', fr: 'Botaniste'},
  95: {en: 'Butcher', fr: 'Boucher, Bouchère'},
  96: {en: 'Bread Baker', fr: 'Boulanger, Boulangère'},
  97: {en: 'Beer Brewer', fr: 'Brasseur de bière'},
  98: {en: 'Bricklayer', fr: 'Briqueteur, Briqueteuse'},
  99: {en: 'Second Hand Dealer', fr: 'Brocanteur, Brocanteuse'},
  100: {en: 'Lead Burner', fr: 'Brûleur, Brûleuse de plomb'},
  101: {en: 'Lumberjack', fr: 'Bûcheron, Bûcheronne'},
  102: {
    en: 'Underground Mine Senior Manager/Vice President/President with No Underground Work',
    fr: "Cadre supérieur, Président, Vice–président mines souterraines (n'allant pas sous terre)",
  },
  103: {
    en: 'Underground Mine Senior Manager/Vice President/President with Less than 10% Underground Work',
    fr: 'Cadre supérieur, Président, Vice–Président mines souterraines (allant sous terre moins de 10 %)',
  },
  104: {
    en: 'Underground Mine Senior Manager/Vice President/President 10% or More Underground Work',
    fr: 'Cadre supérieur, Président, Vice–Président mines souterraines (allant sous terre 10 % et plus)',
  },
  105: {en: 'Penitentiary Senior Manager', fr: 'Cadre supérieur, pénitencier'},
  106: {en: 'Prison Senior Manager', fr: 'Cadre supérieur prison'},
  107: {
    en: 'Senior Manager/Vice–President/President – Other',
    fr: 'Cadre supérieur, Président, Vice–Président autres',
  },
  108: {en: 'Financial Institution Teller', fr: 'Caissier, Caissière institution financière'},
  109: {en: 'Cashier – Other', fr: 'Caissier, Caissière autres'},
  110: {en: 'Insulator', fr: 'Calorifugeur, Calorifugeuse'},
  111: {en: 'Newspaper Carrier', fr: 'Camelot'},
  112: {en: 'Camera Operator – In Studio', fr: 'Caméraman, Camérawoman studio'},
  113: {en: 'Camera Operator – Outside Studio', fr: 'Caméraman, Camérawoman extérieure'},
  114: {
    en: 'Truck Driver, Driver, Delivery Person – Power Shovel',
    fr: 'Camionneur, Camionneuse, Chauffeur, Chauffeuse,  Livreur, Livreuse pelle mécanique',
  },
  115: {
    en: 'Truck Driver, Driver or Delivery Person for Semi–Trailer or Trailer – With or Without Forklift Handling',
    fr: 'Camionneur, Camionneuse, Chauffeur, Chauffeuse, Livreur, Livreuse semi–remorque ou remorque (avec ou sans manipulation de chariot élévateur)',
  },
  116: {
    en: 'Truck Driver, Driver, Delivery Person – Tow Truck',
    fr: 'Camionneur, Camionneuse, Chauffeur, Chauffeuse, Livreur, Livreuse dépanneuse',
  },
  117: {
    en: 'Truck Driver, Driver, Delivery Person – Crane',
    fr: 'Camionneur, Camionneuse, Chauffeur, Chauffeuse, Livreur, Livreuse grue',
  },
  118: {
    en: 'Truck Driver, Driver or Delivery Person for  Armoured Explosives Transportation',
    fr: "Camionneur, Camionneuse, Chauffeur, Chauffeuse, Livreur, Livreuse transport d'explosif, blindéentra",
  },
  119: {
    en: 'Truck Driver, Driver, Delivery Person –  Other',
    fr: 'Camionneur, Camionneuse, Chauffeur, Chauffeuse, Livreur, Livreuse autres',
  },
  120: {en: 'Caricaturist', fr: 'Caricaturiste'},
  121: {en: 'Tile Layer', fr: 'Carreleur, Carreleuse'},
  122: {en: 'Cartographer', fr: 'Cartographe'},
  123: {en: 'Stunt Person', fr: 'Cascadeur, Cascadeuse'},
  124: {en: 'Casino – All Categories', fr: 'Casino (toutes catégories)'},
  125: {en: 'Residential Care Homes for Seniors Worker', fr: 'Centre hébergement pour personnes âgées'},
  126: {
    en: 'Shelter for People with Disabilities Worker',
    fr: 'Centre hébergement pour personnes handicapées',
  },
  127: {en: 'Orphan Shelter Worker', fr: 'Centre hébergement pour personnes orphelines'},
  128: {en: 'Singer', fr: 'Chanteur, Chanteuse'},
  129: {en: 'Lecturer', fr: 'Chargé, Chargée de cours'},
  130: {en: 'Project Manager – Office Only', fr: 'Chargé, Chargée de projet bureau seulement'},
  131: {en: 'Field Project Manager', fr: 'Chargé, Chargée de projet sur le terrain'},
  132: {en: 'Carpenter', fr: 'Charpentier, Charpentière'},
  133: {en: 'Bellhop – Hotel', fr: 'Chasseur, Chasseuse hôtel'},
  134: {en: 'Bellhop – Other', fr: 'Chasseur, Chasseuse autres'},
  135: {en: 'Coppersmith', fr: 'Chaudronnier, Chaudronnière'},
  136: {en: 'Ambulance Driver', fr: 'Chauffeur,Chauffeuse, Conducteur, Conductrice ambulance'},
  137: {en: 'Bus Driver', fr: 'Chauffeur, Chauffeuse, Conducteur, Conductrice autobus'},
  138: {en: 'Train Conductor', fr: 'Chauffeur, Chauffeuse, Conducteur, Conductrice train'},
  139: {en: 'Private Chauffer or Driver', fr: 'Chauffeur, Chauffeuse, Conducteur, Conductrice privé'},
  140: {
    en: 'Race Driver– All Motor Vehicles (see exclusions)',
    fr: 'Pilote de course tous véhicules motorisés (voir exclusions)',
  },
  141: {en: 'Taxi Driver', fr: 'Chauffeur, Chauffeuse, Conducteur, Conductrice taxi'},
  142: {en: 'Fire Chief – Monitoring Only', fr: 'Chef Pompier, Pompière, pompière (surveillance seulement)'},
  143: {en: 'Drilling Site Manager', fr: 'Chef chantier de forage'},
  144: {en: 'Chef', fr: 'Chef cuisinier, Chef cuisinière'},
  145: {en: 'Chemist – No Laboratory Work', fr: 'Chimiste aucun travail en laboratoire'},
  146: {
    en: 'Chemist – Laboratory With No Exposure to Nuclear Radiation',
    fr: 'Chimiste laboratoire non exposé aux émanations nucléaires',
  },
  147: {
    en: 'Chemist – Laboratory With Exposure to Nuclear Radiation',
    fr: 'Chimiste laboratoire exposé aux émanations nucléaires',
  },
  148: {en: 'Chiropractor', fr: 'Chiropraticien, Chiropraticienne'},
  149: {en: 'Surgeon', fr: 'Chirurgien, Chirurgienne'},
  150: {en: 'Choreographer', fr: 'Chorégraphe'},
  151: {en: 'Hairstylist', fr: 'Coiffeuse, coiffeur'},
  152: {en: 'Comedian', fr: 'Comédien, Comédienne'},
  153: {en: 'Aircraft Captain – see exclusions', fr: 'Commandant de bord (voir exclusions)'},
  154: {en: 'Clerk – Office', fr: 'Commis bureau'},
  155: {en: 'Clerk – Ticket Office', fr: 'Commis ventes de billets, guichet, comptoir'},
  156: {en: 'Clerk  – Other', fr: 'Commis autres'},
  157: {en: 'Composer', fr: 'Compositeur, Compositrice'},
  158: {
    en: 'Certified Accountant (CA, CGA, RIA, CMA, CPA)',
    fr: 'Comptable avec certificat CA, CGA, RIA CMA CPA',
  },
  159: {en: 'Accountant (Non–Certified)', fr: 'Comptable sans certificat'},
  160: {en: 'Automotive Dealer', fr: 'Concessionnaire automobile'},
  161: {en: 'Janitor – Not Living on Site', fr: 'Concierge ne vivant pas sur les lieux'},
  162: {en: 'Janitor – Living on Site', fr: 'Concierge vivant sur les lieux'},
  163: {
    en: 'Guidance Counsellor – Labour Relations',
    fr: 'Conseiller, Conseillière orientation, relations de travail',
  },
  164: {en: 'Set Builder', fr: 'Constructeur , Constructrice décor'},
  165: {
    en: 'Derrick, Tank, Platform, Reservoir Builder',
    fr: 'Constructeur, Constructrice derricks, citernes, plates–formes, réservoirs',
  },
  166: {
    en: 'Commercial or Industrial Consultant – With Bachelor’s Degree',
    fr: 'Consultant, Consultante, commercial ou industriel avec BAC',
  },
  167: {
    en: 'Commercial or Industrial Consultant – Without Bachelor’s Degree',
    fr: 'Consultant, Consultante, commercial ou industriel sans BAC',
  },
  168: {en: 'Foreman – Mine', fr: 'Contremaître, Contremaîtresse mine'},
  169: {en: 'Foreman – Marine Port', fr: 'Contremaître, Contremaîtresse port maritime'},
  170: {en: 'Foreman – Explosives Factory', fr: "Contremaître, Contremaîtresse manufacture d'explosifs"},
  171: {en: 'Foreman – Other', fr: 'Contremaître, Contremaîtresse autres'},
  172: {en: 'Controller – Accounting', fr: 'Contrôleur, Contrôleuse comptabilité'},
  173: {en: 'Controller – Mine', fr: 'Contrôleur, Contrôleuse mine'},
  174: {en: 'Controller – Marine Port', fr: 'Contrôleur, Contrôleuse port maritime'},
  175: {en: 'Controller – Air Transport', fr: 'Contrôleur, Contrôleuse aérien'},
  176: {
    en: 'Conference and Event Coordinator',
    fr: "Coordonnateur, Coordonnatrice de congrès et d'événements",
  },
  177: {en: 'Aircraft Co-pilot (see exclusions)', fr: 'Copilote aérien (voir exclusions)'},
  178: {en: 'Shoemaker', fr: 'Cordonnier, Cordonnière'},
  179: {en: 'Proofreader', fr: "Correcteur, Correctrice d'épreuve"},
  180: {
    en: 'Certified Insurance Broker, Agent,  (e.g., AVA, CFP, LL.B., CA)',
    fr: 'Courtier, Courtière, Agent, Agente, Représentant, Représentante,  assurance avec certification, telle que AVA, CFP, bachelier en droit, CA.',
  },
  181: {
    en: 'Certified Financial Security Advisor (e.g., AVA, CFP, LL.B., CA)',
    fr: 'Conseiller, Conseillière en sécurité financière assurance avec certification, telle que AVA, CFP, bachelier en droit, CA.',
  },
  182: {
    en: 'Non–Licensed Insurance Agent or Broker',
    fr: 'Courtier, Courtière, Agent, Agente, Représentant, Représentante,  assurance sans certification',
  },
  183: {
    en: 'Non–Licensed Financial Security Advisor',
    fr: 'Conseiller, Conseillière en sécurité financière assurance sans certification',
  },
  184: {
    en: 'Agent or Broker – Other (not on the stock exchange)',
    fr: 'Courtier, Courtière, Agent, Agente, Représentant, Représentante,  autres (pas à la Bourse)',
  },
  185: {
    en: 'Real Estate Agent or Broker – More Than 2 Years of Experience',
    fr: "Courtier, Courtière, Agent, Agente,  immobilier depuis plus de 2 ans d'expérience",
  },
  186: {
    en: 'Broker, Agent, – Other (including on the Stock Exchange)',
    fr: 'Courtier, Courtière, Agent, Agente,  autres (incluant à la Bourse)',
  },
  187: {
    en: 'Real Estate Agent or Broker –  Less Than 2 Years of Experience',
    fr: 'Courtier, Courtière, Agent, Agente,  immobilier depuis moins de 2 ans',
  },
  188: {en: 'Seamstress', fr: 'Couturier, Couturière'},
  189: {en: 'Roofer', fr: 'Couvreur, Couvreuse'},
  190: {
    en: 'Jewelry Maker – With Hand Tools Only',
    fr: "Créateur, Créatrice de bijoux se servant d'outils à main seulement",
  },
  191: {en: 'Jewelry Maker – With Machinery', fr: 'Créateur, Créatrice de bijoux utilisant de la machinerie'},
  192: {en: 'Dealer', fr: 'Croupier, Croupière'},
  193: {en: 'Cook', fr: 'Cuisinier, Cuisinière'},
  194: {
    en: 'Farmer Owner – Supervisory or Administrative Work Only',
    fr: 'Cultivateur, Cultivatrice propriétaire (supervision ou travail administratif seulement)',
  },
  195: {
    en: 'Farmer Owner – With Manual Labour',
    fr: 'Cultivateur, Cultivatrice propriétaire (avec travail manuel)',
  },
  196: {en: 'Farmer – Non–Owner', fr: 'Cultivateur, Cultivatrice non propriétaire'},
  197: {en: 'Priest', fr: 'Curé'},
  198: {
    en: 'Professional Dancer – Strip Club',
    fr: 'Danseur, danseuse professionnel(le) dans bar de danseurs ou danseuses nues',
  },
  199: {en: 'Professional Dancer – Other', fr: 'Danseur, Danseuse professionel autres'},
  200: {en: 'Dock Worker', fr: 'Débardeur, Débardeuse, Déchargeur, Déchargeuse'},
  201: {en: 'Auto  Body Worker', fr: 'Débosseleur, Débosseleuse, Carrossier, Carrossière'},
  202: {en: 'Brush Cutter', fr: 'Débrouissalleur, Dérbouisalleuse'},
  203: {en: 'Interior Decorator', fr: "Décorateur, Décoratrice d'intérieur"},
  204: {en: 'Furniture Mover', fr: 'Déménageur, Déménageuse de meubles'},
  205: {en: 'Demolition Worker', fr: 'Démolisseur, Démolisseuse de bâtiments'},
  206: {en: 'Dentist', fr: 'Dentiste'},
  207: {en: 'Denturologist', fr: 'Denturologiste'},
  208: {en: 'Interior Designer', fr: "Designer d'intérieur"},
  209: {en: 'Designer – Fashion, Costumes', fr: 'Dessinateur, Dessinatrice mode, costumes'},
  210: {en: 'Designer  –Other', fr: 'Dessinateur, Dessinatrice autres'},
  211: {en: 'Private Detective', fr: 'Détective privé'},
  212: {en: 'Film or Photo Developer', fr: 'Développeur, Développeuse, Développeuse de film ou de photos'},
  213: {en: 'Dietitian', fr: 'Diététicien, diététiste'},
  214: {en: 'Penitentiary Manager', fr: 'Directeur, Directrice, Gestionnaire, Administrateur pénitencier'},
  215: {en: 'Prison Manager', fr: 'Directeur, Directrice, Gestionnaires, Administrateur prison'},
  216: {
    en: 'Underground Mine Manager – No Underground Work',
    fr: "Directeur, Directrice, Gestionnaire, Administrateur mines souterraines (n'allant pas sous terre)",
  },
  217: {
    en: 'Underground Mine Manager – Less than 10% Underground Work',
    fr: 'Directeur, Directrice, Gestionnaire, Administrateur mines souterraines (allant sous terre moins de 10 %)',
  },
  218: {
    en: 'Underground Mine Manager – More than 10% Underground Work',
    fr: 'Directeur, Directrice, Gestionnaire, Administrateur mines souterraines (allant sous terre 10 % et plus)',
  },
  219: {en: 'Manager – Other', fr: 'Directeur, Directrice, Gestionnaire, Administrateur autres'},
  220: {en: 'Disc Jockey', fr: 'Disc Jockey'},
  221: {en: 'Private Servant', fr: 'Domestique privé'},
  222: {en: 'Domestic or Farm Animal Trainer', fr: "Dompteur, Dompteuse animaux domestiques ou d'élevage"},
  223: {en: 'Wild Animal Trainer', fr: "Dompteur, Dompteuse d'animaux sauvages"},
  224: {en: 'Domestic or Farm Animal Trainer', fr: "Dresseur, Dresseuse animaux domestiques ou d'élevage"},
  225: {en: 'Wild Animal Trainer', fr: "Dresseur, Dresseuse d'animaux sauvages"},
  226: {en: 'Blaster', fr: 'Dynamiteur, Dynamiteuse'},
  227: {en: 'Cabinetmaker', fr: 'Ébéniste'},
  228: {en: 'Garbage Collector/ Waste Collector', fr: 'Éboueur, Éboueuse collecte de déchets'},
  229: {en: 'Lighting Technician', fr: 'Éclairagiste'},
  230: {en: 'Economist', fr: 'Économiste'},
  231: {en: 'Writer', fr: 'Écrivain, Écrivaine'},
  232: {en: 'Editer', fr: 'Éditeur, Éditrice'},
  233: {
    en: 'Licensed Child Care Educator – Outside of the Home With Administrative Work Only',
    fr: "Éducateur, Éducatrice garderie autorisée à l'extérieur du domicile avec travail administratif seulement",
  },
  234: {
    en: 'Licensed Child Care Educator – Outside of the Home',
    fr: "Éducateur, Éducatrice garderie autorisée à l'extérieur du domicile",
  },
  235: {
    en: 'Non–Licenced Home Child Care Educator',
    fr: 'Éducateur, Éducatrice garderie non autorisée ou à domicile',
  },
  236: {en: 'Tree Pruner', fr: 'Élagueur, Élagueuse'},
  237: {
    en: 'Electrician – Contractor/Owner',
    fr: 'Électricien, Électricienne propriétaire (Entrepreneur, Entrepreneuse, Entrepreneure)',
  },
  238: {en: 'Salaried Electrician', fr: 'Électricien, Électricienne salarié'},
  239: {en: 'Electrologist', fr: 'Électrolyse'},
  240: {en: 'Electronic Technician', fr: 'Électronicien, Électronicienne'},
  241: {en: 'Domestic Animal Breeder', fr: "Éleveur, Éleveuse d'animaux domestiques"},
  242: {en: 'Livestock Producer', fr: "Éleveur, Éleveuse d'animaux d'élevages"},
  243: {en: 'Wild Animal Keeper', fr: "Éleveur, Éleveuse d'animaux sauvages"},
  244: {en: 'Enameller', fr: 'Émailleur, Émailleuse'},
  245: {en: 'Embalmer', fr: 'Embaumeur, Embaumeuse'},
  246: {en: 'Tree pruner', fr: 'Émondeur, Émondeuse ébrancheur, élagueur'},
  247: {en: 'Auctioneer', fr: 'Encanteur, Encanteuse'},
  248: {en: 'Private Investigator', fr: 'Enquêteur, Enquêtrice privé'},
  249: {
    en: 'Teacher – Physical Education',
    fr: "Enseignant, Enseignante institution académique d'éducation physique",
  },
  250: {en: 'Teacher – Dance School', fr: 'Enseignant, Enseignante institution académique de danse'},
  251: {
    en: 'Teacher – Other Subjects',
    fr: "Enseignant, Enseignante institution académique d'autres disciplines",
  },
  252: {
    en: 'Contractor – Forestry – But Outside the Forest and Administrative Work Only',
    fr: "Entrepreneur, Entrepreneuse, Entrepreneure forestier, mais à l'extérieur de la forêt avec travail administratif seulement",
  },
  253: {en: 'Contractor – Forestry', fr: 'Entrepreneur, Entrepreneuse, Entrepreneur forestier'},
  254: {en: 'Contractor – Construction', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure en construction'},
  255: {en: 'Contractor – Electrical', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure électricien'},
  256: {en: 'Contractor – Plumber', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure plombier'},
  257: {en: 'Contractor – Renovation', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure rénovations'},
  258: {en: 'Contractor – Residential', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure résidentiel'},
  259: {
    en: 'Contractor – Interior Systems',
    fr: 'Entrepreneur, Entrepreneuse, Entrepreneure systèmes intérieurs',
  },
  260: {en: 'Contractor – Excavation', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure excavation'},
  261: {
    en: 'Contractor – Formwork, Foundation',
    fr: 'Entrepreneur, Entrepreneuse, Entrepreneure coffrage, fondation',
  },
  262: {en: 'Contractor – Roofing', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure toiture'},
  263: {
    en: 'Contractor – Painting, Drywalling',
    fr: 'Entrepreneur, Entrepreneuse, Entrepreneure peintre, tireur de joints',
  },
  264: {en: 'Contractor – Masonry', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure maçonnerie'},
  265: {
    en: 'Contractor – Paving, Asphalting',
    fr: 'Entrepreneur, Entrepreneuse, Entrepreneure pavage, asphaltage',
  },
  266: {en: 'Contractor – General', fr: 'Entrepreneur, Entrepreneuse, Entrepreneure général'},
  267: {en: 'HVAC System Maintenance', fr: 'Entretien système chauffage ou de climatisation'},
  268: {
    en: 'Private Home Housekeeping – Employee or Registered Self–Employed',
    fr: 'Entretien ménager maisons privées (employés ou autonome enregistré)',
  },
  269: {en: 'Commercial Housekeeping', fr: 'Entretien ménager commercial'},
  270: {en: 'Residential Housekeeping', fr: 'Entretien ménager résidentiel'},
  271: {en: 'Environmentalist', fr: 'Environnementaliste'},
  272: {en: 'Splicer', fr: 'Épisseur'},
  273: {
    en: 'Boat Crew – Other Than Deck Officer',
    fr: "Marin, Marine Équipage de bateau, autres qu'Officier, Officière de pont",
  },
  274: {en: 'Occupational Therapist', fr: 'Ergothérapeute'},
  275: {en: 'Esthetician', fr: 'Esthéticienne, Esthéticien'},
  276: {
    en: 'Claim Adjuster or Representative – Office Only',
    fr: 'Estimateur, Estimatrice ou Expert, Experte en sinistre au bureau seulement',
  },
  277: {
    en: 'Claim Adjuster or Representative – In the Field',
    fr: 'Estimateur, Estimatrice ou Expert, Experte en sinistre sur le terrain',
  },
  278: {en: 'Window Dresser', fr: 'Étalagiste'},
  279: {en: 'Labeller', fr: 'Étiqueteur, Étiqueteuse'},
  280: {
    en: 'Certified Claim Adjuster – Office Only',
    fr: 'Évaluateur, Évaluatrice en sinistre agréé au bureau seulement',
  },
  281: {
    en: 'Non-certified Claim Adjuster – Office Only',
    fr: 'Évaluateur, Évaluatrice en sinistre non agréé au bureau seulement',
  },
  282: {
    en: 'Certified or Non–certified Claim Adjuster –  In the Field',
    fr: 'Évaluateur, Évaluatrice en sinistre agréé ou non agréé sur le terrain',
  },
  283: {
    en: 'Claim Adjuster – Greenhouse Operator',
    fr: 'Évaluateur, Évaluatrice en sinistre Exploitant de serres',
  },
  284: {en: 'Claim Adjuster – Exterminator', fr: 'Évaluateur, Évaluatrice en sinistre Exterminateur'},
  286: {
    en: 'Jewelry Maker – With Machinery',
    fr: 'Fabricant, Fabricante de bijoux utilisant de la machinerie',
  },
  287: {en: 'Letter Carrier', fr: 'Facteur, Factrice'},
  288: {en: 'Housekeeper', fr: 'Femme, Homme de chambre'},
  289: {en: 'Tinsmith – Workshop Only', fr: 'Ferblantier, Ferblantière atelier seulement'},
  290: {en: 'Tinsmith – External', fr: 'Ferblantier, Ferblantière extérieur'},
  291: {
    en: 'Farmer Owner – Supervisory or Administrative Work Only',
    fr: 'Fermier, Fermière propriétaire (supervision ou travail administratif seulement)',
  },
  292: {en: 'Farmer Owner – With Manual Labour', fr: 'Fermier, Fermière propriétaire (avec travail manuel)'},
  293: {en: 'Farmer Non-Owner', fr: 'Fermier, Fermière non propriétaire'},
  294: {en: 'Scrap Metal Salesperson', fr: 'Ferrailleur, Ferrailleuse'},
  295: {en: 'Ironworker – Workshop Only', fr: 'Ferronnier, Ferronnière de fer forger atelier seulement'},
  296: {en: 'Ironworker – Exterior', fr: 'Ferronnier, Ferronnière de fer forger extérieur'},
  297: {en: 'Concrete or Cement Finisher', fr: 'Finisseur, Finnisseuse de béton ou de ciment'},
  298: {en: 'Tax Specialist', fr: 'Fiscaliste'},
  299: {en: 'Florist – Store', fr: 'Fleuriste magasin'},
  300: {en: 'Florist – Greenhouse', fr: 'Fleuriste serre'},
  301: {en: 'Flower Grower', fr: 'Floriculteur, Floricultrice'},
  302: {en: 'Melter', fr: 'Fondeur, Fonseuse'},
  303: {en: 'Armed Forces (see exclusions)', fr: 'Forces armées (voir exclusions)'},
  304: {en: 'Driller – Without Dynamite', fr: 'Foreur, Foreuse sans dynamite'},
  305: {en: 'Driller – With Dynamite', fr: 'Foreur, Foreuse avec dynamite'},
  306: {en: 'Blacksmith – Excluding Paddock Blacksmith', fr: 'Forgeron, Forgeronne (sauf maréchal ferrant)'},
  307: {en: 'Cheese Maker', fr: 'Fromager, Fromagère'},
  308: {en: 'Fumigator', fr: 'Fumigateur'},
  309: {en: 'Galvanizer', fr: 'Galvaniseur, Galvaniseuse'},
  310: {en: 'Stable Person', fr: "Garçon, Fille d'écurie"},
  311: {en: 'Conservation Officer', fr: 'Gardien, Gardienne chasse'},
  312: {en: 'Fishery Guardian', fr: 'Gardien, Gardienne pêche'},
  313: {en: 'Forest Ranger – Without Flying', fr: 'Gardien, Gardienne forestier sans aviation'},
  314: {en: 'Security Guard – Unarmed', fr: 'Gardien, Gardienne de sécurité (non armé)'},
  315: {en: 'Body Guard –Unarmed', fr: 'Garde du corps (non armé)'},
  316: {en: 'Prison Guard – Armed or Unarmed', fr: 'Gardien, Gardienne de prison (armé ou non armé)'},
  317: {en: 'Security Guard – Armed', fr: 'Gardien, Gardienne de sécurité (armé)'},
  318: {en: 'Body Guard – Armed', fr: 'Garde du corps (armé)'},
  319: {
    en: 'Forest Ranger – With Flying (see exclusions)',
    fr: 'Gardien, Gardienne forestier avec aviation (voir exclusions)',
  },
  320: {
    en: 'Conservation Officer – With Flying (see exclusions)',
    fr: 'Gardien, Gardienne chasse avec aviation (voir exclusions)',
  },
  321: {
    en: 'Fishery Guardian – With Flying (see exclusions)',
    fr: 'Gardien, Gardienne pêche avec aviation (voir exclusions)',
  },
  322: {
    en: 'Live–In Caregiver – With Live–In Caregiver Program Work Permit',
    fr: "Gardien, Gardienne d'enfant résident au domicile employeur avec permis de travail du Programme des aides familiaux",
  },
  323: {
    en: 'Live–In Caregiver – Other',
    fr: "Gardien, Gardienne d'enfant résident au domicile employeurs, autres",
  },
  324: {en: 'Geologist – Office Only', fr: 'Géologue au bureau seulement'},
  325: {
    en: 'Geologist – In the Field (except mining and oil)',
    fr: 'Géologue sur le terrain (sauf mines et pétrole)',
  },
  326: {en: 'Field Geologist – Mining or Oil', fr: 'Géologue mines ou pétrole sur les chantiers'},
  327: {en: 'Surveyor', fr: 'Géomètre'},
  328: {en: 'Manager – No Manual Labour', fr: 'Gérant, Gérante sans travail manuel'},
  329: {en: 'Manager – With Manual Labour', fr: 'Gérant, Gérante avec travail manuel'},
  330: {en: 'Farm Manager', fr: 'Gérant, Gérante de ferme'},
  331: {en: 'Manager', fr: 'Gestionnaire'},
  332: {
    en: 'Live–In Nanny – With Live–In Caregiver Program Work Permit',
    fr: "Gouvernante, Gouvernant résident au domicile de l'employeur avec permis de travail du Programme des aides familiaux",
  },
  333: {en: 'Live–In Nanny – Other', fr: 'Gouvernante, Gouvernant résident au domicile employeur, autres'},
  334: {en: 'Graphic Designer', fr: 'Graphiste'},
  335: {en: 'Engraver', fr: 'Graveur, Graveuse'},
  336: {en: 'Tourism Guide', fr: 'Guide tourisme'},
  337: {en: 'Hunting and Fishing Guide', fr: 'Guide chasse et pêche'},
  338: {en: 'Mountain Guide', fr: 'Guide montagne'},
  339: {en: 'Rock Climbing guide', fr: 'Guide escalade'},
  340: {en: 'Heli-Skiing Guide', fr: 'Guide héliski'},
  341: {en: 'Backcountry Skiing Guide', fr: 'Guide ski hors–piste'},
  342: {en: 'Mountain Biking Guide', fr: 'Guide vélo de montagne'},
  343: {en: 'Catskiing Guide', fr: 'Guide catski'},
  344: {en: 'Dresser', fr: 'Habilleur, Habilleuse'},
  345: {en: 'Homeopath', fr: 'Homéopathe'},
  346: {en: 'Clockmaker', fr: 'Horloger, Horlogère'},
  347: {en: 'Horticulturist', fr: 'Horticulteur, Horticultrice'},
  348: {en: 'Host – Hotel, Restaurant', fr: 'Hôtesse, Hôte (hôtel , restaurant)'},
  349: {en: 'Bailiff –Court', fr: 'Huissier, Huissière à la cour'},
  350: {en: 'Bailiff – Outside of the Court', fr: 'Huissier, Huissière extérieur de la cour'},
  351: {en: 'Dental Hygienist', fr: 'Hygiéniste dentaire'},
  352: {en: 'Hypnotherapist', fr: 'Hypnothérapeute'},
  353: {en: 'Illustrator', fr: 'Illustrateur, Illustratrice'},
  354: {en: 'Impresario', fr: 'Imprésario'},
  355: {en: 'Printer', fr: 'Imprimeur, Imprimeuse'},
  356: {
    en: 'Graduate and/or Registered Nurse –Office or Supervision Only',
    fr: 'Infirmier, Infirmière diplômé et/ou spécialisé, bureau ou supervision seulement',
  },
  357: {en: 'Graduate and/or Registered Nurse', fr: 'Infirmier, Infirmière diplômée et/ou spécialisée'},
  358: {en: 'Auxillary Nurse', fr: 'Infirmier, Infirmière auxiliaire'},
  359: {en: 'Influencer', fr: 'Influenceur, Influenceuse'},
  360: {en: 'Computer Graphics Designer', fr: 'Infographiste'},
  361: {
    en: 'IT – System Administrator',
    fr: 'Informatique Administrateur, Administratrice, administratrice système',
  },
  362: {en: 'IT – Technical Support Officer', fr: 'Informatique Agent, Agente,  de soutien technique'},
  363: {en: 'IT – Data Scientist', fr: 'Informatique scientifique des données'},
  364: {en: 'IT – Web Graphics Designer', fr: 'Informatique Designer graphique web'},
  365: {en: 'IT – Data Analyst', fr: 'Informatique Analyste de donnée'},
  366: {en: 'IT – Data Architect', fr: 'Informatique Architecte de données'},
  367: {en: 'IT – Cloud Architect', fr: 'Informatique Architecte Cloud'},
  368: {en: 'IT – Web Administrator', fr: 'Informatique Webmestre'},
  369: {en: 'IT – UX Designer', fr: 'Informatique Designer d’expérience utilisateur (UX)'},
  370: {en: 'IT – Computer Engineer', fr: 'Informatique Ingénieur,  informaticien informaticienne'},
  371: {en: 'IT – Network Administrator', fr: 'Informatique Administrateur, Administratrice réseau'},
  372: {en: 'IT – Business Intelligence Analyst', fr: 'Informatique Analyste en intelligence d’affaires'},
  373: {en: 'IT – IT Analyst', fr: 'Informatique Analyste informatique'},
  374: {en: 'IT – Web Programmer', fr: 'Informatique Programmeur, Programmeuse web'},
  375: {en: 'IT – Full Stack Developer', fr: 'Informatique Développeur, Développeuse Full–Stack'},
  376: {en: 'IT – Computer Security Analyst', fr: 'Informatique Analyste en sécurité informatique'},
  377: {
    en: 'IT – App or Interactive Media Developer',
    fr: 'Informatique Développeur, Développeuse d’applications (ou en médias interactifs)',
  },
  378: {en: 'IT – Manager, Web Project Leader', fr: 'Informatique Chef, chargé de projet web'},
  379: {en: 'IT – DevOps Engineer', fr: 'Informatique Ingénieur, Ingénieure, DevOps'},
  380: {en: 'Product Owner', fr: 'Product owner - Responsable de produit'},
  381: {en: 'Scrum master', fr: 'Scrum master'},
  382: {en: 'Business Analyst', fr: "Analyste d'affaires"},
  383: {
    en: 'IT – Consultant, Advisor',
    fr: 'Informatique Consultant, Consultante, Conseillière, Conseiller',
  },
  384: {
    en: 'Civil Engineer – Up to 10 Hours per Week on Site',
    fr: 'Ingénieur, Ingénieure,  civil (maximum 10 heures par semaine sur le chantier)',
  },
  385: {
    en: 'Forest Engineer – Less Than 10% Field Work',
    fr: 'Ingénieur, Ingénieure, forestier (allant sur le terrain 10 % et moins)',
  },
  386: {
    en: 'Underground Oil Reservoir Engineer – Administrative Work Only',
    fr: 'Ingénieur, Ingénieure, gisement pétroliers en sous–sol avec travail administratif seulement',
  },
  387: {
    en: 'Civil Engineer – More Than 10 Hours Per Week on Site',
    fr: 'Ingénieur, Ingénieure,  civil (plus de 10 heures par semaine sur le chantier)',
  },
  388: {
    en: 'Forest engineer – More Than 10% Field Work',
    fr: 'Ingénieur, Ingénieure, forestier (allant sur les chantiers 10 % et plus)',
  },
  389: {
    en: 'Underground Oil Reservoir Engineer – In the Field',
    fr: 'Ingénieur, Ingénieure,  gisement pétrolier en sous–sol (allant sur les chantiers)',
  },
  390: {en: 'Sound Engineer', fr: 'Ingénieur, Ingénieure,  de son'},
  391: {
    en: 'Underwater Petroleum Reservoir Engineer',
    fr: 'Ingénieur, Ingénieure, gisements pétroliers sous–marins',
  },
  392: {en: 'Engineer – Other', fr: 'Ingénieur, Ingénieure,  autres'},
  393: {en: 'Inhalation Therapist', fr: 'Inhalothérapeute'},
  394: {
    en: 'Artificial Inseminator – Animal Breeding',
    fr: 'Inséminateur, Inséminatrice (insémination animale)',
  },
  395: {en: 'Building Inspector', fr: 'Inspecteur, Inspectrice bâtiment'},
  396: {en: 'Health Inspector', fr: 'Inspecteur, Inspectrice sanitaire'},
  397: {
    en: 'Inspector – Underground Petroleum Reservoir (No Manual Work)',
    fr: 'Inspecteur, Inspectrice gisements pétroliers en sous–sol (sans aucun travail manuel)',
  },
  398: {en: 'Inspector – Animal Welfare', fr: 'Inspecteur, Inspectrice bien–être animal'},
  399: {en: 'Inspector – Open Mine Pit', fr: 'Inspecteur, Inspectrice mines à ciel ouvert'},
  400: {
    en: 'Inspector – Underground Mine, Less Than 10% Underground Work',
    fr: 'Inspecteur, Inspectrice mines souterraines (allant sous terre moins de 10 %)',
  },
  401: {en: 'Inspector – Logging', fr: 'Inspecteur, Inspectrice exploitation forestière'},
  402: {en: 'Inspector – High-Voltage Line', fr: 'Inspecteur, Inspectrice ligne à haute tension'},
  403: {
    en: 'Inspector – Underground Mine With More Than 10% Underground Work, Underwater Oil Reservoir',
    fr: 'Inspecteur, Inspectrice mines souterraines (allant sous terre 10 % et plus), gisement pétrolier sous marin',
  },
  404: {en: 'Inspector – Other', fr: 'Inspecteur, Inspectrice autres'},
  405: {
    en: 'Installer – Indoor Telephone Lines',
    fr: "Installateur, Installatrice ligne téléphonique à l'intérieur",
  },
  406: {
    en: 'Installer – Outdoor Telephone Lines',
    fr: "Installateur, Installatrice ligne téléphonique à l'extérieur",
  },
  407: {en: 'Installer – High-Voltage Lines', fr: 'Installateur, Installatrice lignes à haute tension'},
  408: {en: 'Installer – Other', fr: 'Installateur, Installatrice autres'},
  409: {en: 'Instructor – Golf', fr: 'Instructeur, Instructrice, Moniteur, Monitrice golf'},
  410: {en: 'Instructor – Swimming', fr: 'Instructeur, Instructrice, Moniteur, Monitrice natation'},
  411: {en: 'Instructor – Skating', fr: 'Instructeur, Instructrice, Moniteur, Monitrice patinage'},
  412: {en: 'Instructor – Tennis', fr: 'Instructeur, Instructrice, Moniteur, Monitrice tennis'},
  413: {
    en: 'Instructor – Driving  School',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice école de conduite',
  },
  414: {en: 'Instructor – Horseback Riding', fr: 'Instructeur, Instructrice, Moniteur, Monitrice équitation'},
  415: {
    en: 'Instructor – Fitness Training',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice conditionnement physique',
  },
  416: {en: 'Instructor – Trade', fr: 'Instructeur, Instructrice, Moniteur, Monitrice métier'},
  417: {en: 'Instructor – Martial Arts', fr: 'Instructeur, Instructrice, Moniteur, Monitrice arts martiaux'},
  418: {
    en: 'Instructor – Combat Sports',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice sports de combat',
  },
  419: {en: 'Instructor – Rock Climbing', fr: 'Instructeur, Instructrice, Moniteur, Monitrice escalade'},
  420: {en: 'Instructor – Mountain Sports', fr: 'Instructeur, Instructrice, Moniteur, Monitrice montagne'},
  421: {en: 'Instructor – Heli-Skiing', fr: 'Instructeur, Instructrice, Moniteur, Monitrice héliski'},
  422: {en: 'Instructor – Catskiing', fr: 'Instructeur, Instructrice, Moniteur, Monitrice catski'},
  423: {
    en: 'Instructor – Backcountry Skiing',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice ski hors–piste',
  },
  424: {
    en: 'Instructor – Mountain Biking',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice vélo de montagne',
  },
  425: {en: 'Certified Interpreter', fr: 'Interprète agréé'},
  426: {en: 'Non-certified Interpreter', fr: 'Interprète non  agréé'},
  427: {
    en: 'Social Service Worker – Office Only',
    fr: 'Intervenant, Intervenante en services sociaux au bureau seulement',
  },
  428: {
    en: 'Social Service Worker – In the Field',
    fr: 'Intervenant, Intervenante en services sociaux sur le terrain',
  },
  429: {en: 'Insulation Worker', fr: 'Isolateur, Isolatrice'},
  430: {en: 'Gardener', fr: 'Jardinier, Jardinière'},
  431: {en: 'Jointer', fr: 'Jointoyeur, Jointoyeuse'},
  432: {en: 'Slaughterhouse Worker', fr: 'Journalier, Journalière abattoir'},
  433: {en: 'Labourer – Other', fr: 'Journalier, Journalière autres'},
  434: {
    en: 'Journalist – With Bachelor’s Degree (More Than 2 Years of Experience)',
    fr: 'Journaliste avec BAC (plus de 2 ans à son compte)',
  },
  435: {
    en: 'Journalist – Without Bachelor’s Degree (More Than 2 Years of Experience)',
    fr: 'Journaliste sans BAC (plus de 2 ans à son compte)',
  },
  436: {
    en: 'Journalist – with or without Bachelor’s Degree (Less Than 2 Years of Experience)',
    fr: 'Journaliste avec ou sans BAC (moins de 2 ans à son compte)',
  },
  437: {en: 'Journalist – Foreign Correspondent', fr: "Journaliste correspondant à l'étranger"},
  438: {en: 'Court Judge', fr: 'Juge système judiciaire'},
  439: {en: 'Sports Referee', fr: 'Juge sportif'},
  440: {en: 'Kinesiologist', fr: 'Kinésiologue'},
  441: {en: 'Kinesiotherapist', fr: 'Kinésithérapeute'},
  442: {en: 'Washer – Car, Windows', fr: 'Laveur, Laveuse (automobile, vitres)'},
  443: {
    en: 'Delivery Person – Without Handling or With Use of Forklift to Handle Goods',
    fr: 'Livreur, Livreuse sans manipulation ou manipulation de marchandises avec chariot élévateur',
  },
  444: {
    en: 'Delivery Person –  Bicycle/Non–Motorized Newspaper Delivery',
    fr: 'Livreur, Livreuse courrier à bicyclette, journaux non motorisés',
  },
  445: {en: 'Stringed Instrument Maker', fr: 'Luthier, Luthière'},
  446: {en: 'Machinist', fr: 'Machiniste'},
  447: {
    en: 'Mason – Owner (Contractor)',
    fr: 'Maçon, Maçonne propriétaire (Entrepreneur, Entrepreneuse, Entrepreneure)',
  },
  448: {en: 'Mason – Employee', fr: 'Maçon, Maçonne employé'},
  449: {en: 'Maître D', fr: "Maître d'hôtel"},
  450: {en: 'Explosives Handler', fr: "Manipulateur, Manipulatrice d'explosifs"},
  451: {en: 'Model', fr: 'Mannequin'},
  452: {en: 'Manicurist, Pedicurist', fr: 'Manucure, Manucuriste, pédicure, Pédicuriste'},
  453: {en: 'Warehouseperson', fr: 'Manutentionnaire'},
  454: {en: 'Makeup Artist', fr: 'Maquilleur, Maquilleuse'},
  455: {en: 'Paddock Blacksmith', fr: 'Maréchal ferrant, Maréchale ferrant'},
  456: {en: 'Massage Therapist', fr: 'Massothérapeute'},
  457: {en: 'Mechanic', fr: 'Mécanicien, Mécanicienne'},
  458: {en: 'Doctor, Physician', fr: 'Médecin'},
  459: {en: 'Clergy Member', fr: 'Membre du clergé'},
  460: {en: 'Carpenter', fr: 'Menuisier, Menuisière'},
  461: {en: 'Measurer', fr: 'Mesureur, Messureure'},
  462: {en: 'Web Marketing', fr: 'Marketing web'},
  463: {en: 'Marketing Specialist', fr: 'Spécialiste en marketing'},
  464: {en: 'Marketing Researcher', fr: "Chargé, Chargée d'étude en marketing"},
  465: {
    en: 'Mining Metallurgist – No Underground Work',
    fr: "Métallurgiste exploitation minière (n'allant pas sous terre)",
  },
  466: {en: 'Metallurgist – Underground Work', fr: 'Métallurgiste allant sous terre'},
  467: {en: 'Metallurgist – Other', fr: 'Métallurgiste autres'},
  468: {en: 'Meteorologist', fr: 'Météorologue'},
  469: {en: 'Stage Director', fr: 'Metteur, Metteuse en scène'},
  470: {en: 'Mill Worker', fr: 'Meunier, Meunière'},
  471: {en: 'Military (see exclusions)', fr: 'Militaire (voir exclusions)'},
  472: {en: 'Summer Camp Instructor', fr: 'Moniteur, Monitrice camps de vacances'},
  473: {en: 'Sound Editor', fr: 'Monteur, Monteuse son'},
  474: {en: 'Video editor', fr: 'Monteur, Monteuse vidéo'},
  475: {en: 'Line or Factory Worker', fr: 'Monteur, Monteuse de ligne ou en manufacture'},
  476: {en: 'Antenna Worker', fr: 'Monteur, Monteuse antenne'},
  477: {en: 'Tower Worker', fr: 'Monteur, Monteuse de tours'},
  478: {
    en: 'High Voltage Line Worker – Steel Framing (Not in Factory)',
    fr: 'Monteur, Monteuse ligne à haute tension, charpente métallique (pas en manufacture)',
  },
  479: {en: 'Moulder', fr: 'Mouleur, Mouleuse'},
  480: {
    en: 'Musician – Symphony Orchestra Conductor',
    fr: 'Musicien, Musicienne directeur orchestre symphonique',
  },
  481: {en: 'Musician – Symphony Orchestra', fr: 'Musicien, Musicienne orchestre symphonique'},
  482: {en: 'Musician – Studio', fr: 'Musicien, Musicienne studio'},
  483: {en: 'Musician – Radio', fr: 'Musicien, Musicienne radio'},
  484: {en: 'Musician – Television', fr: 'Musicien, Musicienne télévision'},
  485: {en: 'Musician – Other', fr: 'Musicien, Musicienne autres'},
  486: {en: 'Naturopath', fr: 'Naturopathe, Naturothérapeute'},
  487: {en: 'Cleaner – Laundry', fr: 'Nettoyeur, Nettoyeuse blanchisserie'},
  488: {en: 'Cleaner – Carpets', fr: 'Nettoyeur, Nettoyeuse de tapis'},
  489: {
    en: 'Cleaner – Factory (no toxic materials)',
    fr: 'Nettoyeur, Nettoyeuse usine (sauf de produits toxiques)',
  },
  490: {en: 'Cleaner – Sandblaster', fr: 'Nettoyeur, Nettoyeuse jet de sable'},
  491: {en: 'Cleaner - Septic Tank', fr: 'Nettoyeur, Nettoyeuse fosse septique'},
  492: {en: 'Cleaner – Factory (toxic materials)', fr: 'Nettoyeur, Nettoyeuse usine de produits toxiques'},
  493: {en: 'Notary', fr: 'Notaire'},
  494: {en: 'Nutritionist', fr: 'Nutritionniste'},
  495: {en: 'Parole Officer', fr: 'Officier, Officière libération'},
  496: {en: 'Probation Officer', fr: 'Officier, Officière probation'},
  497: {en: 'Deck Officer – Liner', fr: 'Officier, Officière de pont sur un paquebot'},
  498: {en: 'Ship Engineer Officer', fr: 'Officier, Officière mécanicien, mécanicienne sur un bateau'},
  499: {
    en: 'Deck Officer – Cargo Ship or Ferry',
    fr: 'Officier, Officière de pont sur un cargo ou un traversier',
  },
  500: {en: 'Deck Officer – Dredger or Tug Ship', fr: 'Officier, Officière un dragueur ou un remorqueur'},
  501: {en: 'Deck Officer – Lightship', fr: 'Officier, Officière de pont sur un bateau phare'},
  502: {en: 'Operator – Telephone Network', fr: 'Opérateur, Opératrice réseau téléphonique'},
  503: {en: 'Operator –Elevator', fr: 'Opérateur, Opératrice ascenseur'},
  504: {en: 'Operator – Press', fr: 'Opérateur, Opératrice presse'},
  505: {en: 'Operator – Printing Press', fr: 'Opérateur, Opératrice presse à imprimer'},
  506: {en: 'Operator – Binder', fr: 'Opérateur, Opératrice relieur'},
  507: {
    en: 'Operator – Other Machinery (except forestry)',
    fr: 'Opérateur, Opératrice autres machinerie (sauf en foresterie)',
  },
  508: {
    en: 'Operator – Other Machinery (Forestry)',
    fr: 'Opérateur, Opératrice autres machinerie (en foresterie)',
  },
  509: {
    en: 'Operator – Excavator (except forestry)',
    fr: 'Opérateur, Opératrice pelle mécanique (sauf en foresterie)',
  },
  510: {en: 'Operator – Excavator (Forestry)', fr: 'Opérateur, Opératrice pelle mécanique (en foresterie)'},
  511: {
    en: 'Operator – Grader (except forestry)',
    fr: 'Opérateur, Opératrice niveleuse (sauf en foresterie)',
  },
  512: {en: 'Operator – Grader (Forestry)', fr: 'Opérateur, Opératrice niveleuse (en foresterie)'},
  513: {en: 'Operator – Crane (except forestry)', fr: 'Opérateur, Opératrice grue (sauf en foresterie)'},
  514: {en: 'Operator – Crane (Forestry)', fr: 'Opérateur, Opératrice grue (en foresterie)'},
  515: {
    en: 'Operator – Bulldozer (except forestry)',
    fr: 'Opérateur, Opératrice bélier mécanique (sauf en forestier)',
  },
  516: {en: 'Operator – Bulldozer (Forestry)', fr: 'Opérateur, Opératrice bélier mécanique (en forestier)'},
  517: {
    en: 'Operator – Loader (except forestry)',
    fr: 'Opérateur, Opératrice appareil de chargement (sauf en forestier)',
  },
  518: {
    en: 'Operator – Loader (Forestry)',
    fr: 'Opérateur, Opératrice appareil de chargement (en forestier)',
  },
  519: {
    en: 'Operator – Skidder (except forestry)',
    fr: 'Opérateur, Opératrice débusqueuse (sauf en forestier)',
  },
  520: {en: 'Operator – Skidder (Forestry)', fr: 'Opérateur, Opératrice débusqueuse (en forestier)'},
  521: {
    en: 'Operator – Machinery (except forestry)',
    fr: 'Opérateur, Opératrice machinerie (sauf en foresterie)',
  },
  522: {en: 'Operator – Machinery (Forestry)', fr: 'Opérateur, Opératrice machinerie (en foresterie)'},
  523: {en: 'Operator – Logging Tractor', fr: 'Opérateur, Opératrice tracteur  en forêt'},
  524: {en: 'Operator – Multipurpose', fr: 'Opérateur, Opératrice multifonctionnelle'},
  525: {en: 'Optician', fr: "Opticien, Opticienne d'ordonnance"},
  526: {en: 'Optician Technician', fr: 'Opticien, Opticienne Technicien, Technicienne'},
  527: {en: 'Laboratory Optician', fr: 'Opticien, Opticienne laboratoire'},
  528: {en: 'Optometrist', fr: 'Optométriste'},
  529: {en: 'Union Organizer', fr: 'Organisateur, Organisatrice syndical'},
  530: {en: 'Event Planner', fr: 'Organisateur, Organisatrice évènement'},
  531: {en: 'Convention Organizer', fr: 'Organisateur, Organisatrice congrès'},
  532: {en: 'Orthotist', fr: 'Orthésiste'},
  533: {en: 'Orthodontist', fr: 'Orthodontiste'},
  534: {en: 'Orthopedist', fr: 'Orthopédiste'},
  535: {en: 'Speech Therapist', fr: 'Orthophoniste'},
  536: {en: 'Orthotherapist', fr: 'Orthothérapeute'},
  537: {en: 'Osteopath', fr: 'Ostéopathe'},
  538: {en: 'Telephone Line Worker', fr: 'Ouvrier, Ouvrière construction de lignes téléphoniques'},
  539: {en: 'Ore Treatment Worker', fr: 'Ouvrier, Ouvrière épuration du minerai'},
  540: {
    en: 'Open Pit Mine Worker – No Explosives',
    fr: "Ouvrier, Ouvrière mines à ciel ouvert n'utilisant pas d'explosifs (mineur)",
  },
  541: {
    en: 'Warehouse/Factory/Plant Worker – No Explosives',
    fr: 'Ouvrier, Ouvrière entrepôt ou usine ou manufacture sans explosifs',
  },
  542: {
    en: 'Warehouse/Factory/Plant Worker – With Explosives',
    fr: "Ouvrier, Ouvrière entrepôt ou usine ou manufacture d'explosifs",
  },
  543: {
    en: 'Underground Drilling Rig Derrick Worker – No Dynamite',
    fr: 'Ouvrier, Ouvrière derrick de forage en sous sous–sol (sans dynamite)',
  },
  544: {en: 'Underwater Drilling Rig Derrick Worker', fr: 'Ouvrier, Ouvrière derrick de forage sous marin'},
  545: {en: 'Underground Mine Worker', fr: 'Ouvrier, Ouvrière mines souterraines (mineur)'},
  546: {
    en: 'Open Pit Mine Worker – With Explosives',
    fr: 'Ouvrier, Ouvrière mines à ciel ouvert utilisant des explosifs (mineur)',
  },
  547: {en: 'Underground Pipeline Worker', fr: 'Ouvrier, Ouvrière canalisations souterraines'},
  548: {en: 'Stable Worker', fr: 'Palefrenier, Palfrenière'},
  549: {en: 'Paramedic', fr: 'Paramédic, Paramédical, Paramédicale'},
  550: {en: 'Floor Maker', fr: 'Parqueteur, Parqueteuse'},
  551: {en: 'Pastor', fr: 'Pasteur, Pasteure'},
  552: {en: 'Pastry Chef', fr: 'Pâtissier, Pâtissière'},
  553: {en: 'Patternmaker', fr: 'Patronnier, Patronnière'},
  554: {en: 'Landscaper', fr: 'Paysagiste'},
  555: {en: 'Fisherman – Saltwater', fr: 'Pêcheur, Pêcheuse eaux côtières'},
  556: {en: 'Ship Owner', fr: 'Pêcheur, Pêcheuse propriétaire de son navire'},
  557: {en: 'Fisherman – Other', fr: 'Pêcheur, Pêcheuse autres'},
  558: {en: 'Painter – Buildings', fr: 'Peintre en bâtiment'},
  559: {en: 'Painter – Bell Towers', fr: 'Peintre clochers'},
  560: {en: 'Painter – High Chimneys', fr: 'Peintre hautes cheminées'},
  561: {en: 'Painter – Bridges', fr: 'Peintre ponts'},
  562: {en: 'Painter – Artist', fr: 'Peintre artiste'},
  563: {en: 'Plant Nursery Worker', fr: 'Pépiniériste'},
  564: {
    en: 'Arcade and Video Game Worker (All Trades)',
    fr: 'Personnel, Employé, Employée arcade et jeux vidéo (tous les métiers)',
  },
  565: {en: 'Circus Worker (All Trades)', fr: 'Personnel, Employé, Employée cirque (tous les métiers)'},
  566: {
    en: 'Amusement Park Worker (All Trades)',
    fr: "Personnel, Employé, Employée parc d'amusement ou d'attractions (tous les métiers)",
  },
  567: {
    en: 'Amusement Ride Worker (All Trades)',
    fr: 'Personnel, Employé, Employée manèges (tous les métiers)',
  },
  568: {en: 'Pharmacist', fr: 'Pharmacien, Pharmacienne'},
  569: {en: 'Photographer – Studio', fr: 'Photographe en studio'},
  570: {en: 'Photographer – Other', fr: 'Photographe autres'},
  571: {
    en: 'Newspaper or Periodical Photoengraver',
    fr: 'Photograveur, Photograveuse journaux ou périodiques',
  },
  572: {en: 'Physiotherapist', fr: 'Physiothérapeute'},
  573: {en: 'Air Pilot (see exclusions)', fr: 'Pilote aérien (voir exclusions)'},
  574: {en: 'Usher', fr: 'Placeur, Placeuse, Placier, Placière'},
  575: {en: 'Conference and Event Planner', fr: "Planificateur, Planificatrice de congrès et d'évènements"},
  576: {en: 'Plasterer', fr: 'Plâtrier, Plâtrière'},
  577: {
    en: 'Plumber – Owner (Contractor)',
    fr: 'Plombier, Plombière propriétaire (Entrepreneur, Entrepreneuse, Entrepreneure)',
  },
  578: {en: 'Plumber – Salaried', fr: 'Plombier, Plombière salarié'},
  579: {en: 'Dishwasher – Hotel', fr: 'Plongeur, Plongeuse hôtel'},
  580: {en: 'Dishwasher – Motel', fr: 'Plongeur, Plongeuse motel'},
  581: {
    en: 'Dishwasher – Restaurant Other than Fast Food',
    fr: 'Plongeur, Plongeuse restaurant autres que restauration rapide',
  },
  582: {en: 'Dishwasher – Other', fr: 'Plongeur, Plongeuse autres'},
  583: {en: 'Underwater Diver', fr: 'Plongeur sous–marin, Plongeuse sous–marine'},
  584: {en: 'Podiatrist', fr: 'Podiatre'},
  585: {en: 'Chiropodist', fr: 'Podologue'},
  586: {en: 'Lumber Tallyman', fr: 'Pointeur, Pointeuse de bois de sciage'},
  587: {en: 'Police – Captain', fr: 'Policier, Policière,  capitaine'},
  588: {en: 'Police – Chief', fr: 'Policier, Policière,  chef'},
  589: {
    en: 'Police – Lieutenant or Inspector ( Office or Court Work Only)',
    fr: 'Policier, Policière,  lieutenant, lieutenante ou Inspecteur, Inspectrice (travail au bureau ou à la cour seulement)',
  },
  590: {en: 'Police – Detective', fr: 'Policier, Policière,  détective'},
  591: {
    en: 'Police – Car or Motorcycle Officer/Investigator',
    fr: 'Policier, Policière,  enquêteur, enquêteuse ou patrouilleur, patrouilleuse en automobile ou motocyclette',
  },
  592: {en: 'Police – Constable', fr: 'Policier, Policière,  constable judiciaire'},
  593: {en: 'Police – Squad (all categories)', fr: 'Policier, Policière,  escouade (toute catégorie)'},
  594: {en: 'Police – Other', fr: 'Policier, Policière,  autres'},
  595: {en: 'Polisher – Jewelry', fr: 'Polisseur, Polisseuse bijoux'},
  596: {en: 'Polisher – Building', fr: 'Polisseur, Polisseuse dans le bâtiment'},
  597: {en: 'Firefighter – Captain', fr: 'Pompier, Pompière capitaine'},
  598: {en: 'Firefighter – Fire Chief', fr: 'Pompier, Pompière, Chef'},
  599: {en: 'Firefighter – Lieutenant', fr: 'Pompier, Pompière, Lieutenant'},
  600: {
    en: 'Firefighter in an Industrial Facility Without Toxic Materials',
    fr: 'Pompier, Pompière dans un établissement industriel sauf dans usine de produits toxiques',
  },
  601: {
    en: 'Firefighter in an Industrial Facility With Toxic Materials',
    fr: "Pompier, Pompière dans un établissement industriel d'une usine de produits toxiques",
  },
  602: {en: 'Firefighter – Other', fr: 'Pompier, Pompière autres'},
  603: {en: 'Pump Operator', fr: 'Pompiste'},
  604: {en: 'Baggage Handler', fr: 'Porteur, Porteuse de bagages'},
  605: {en: 'Door Attendant', fr: 'Portier, Portière'},
  606: {
    en: 'Layer – All Categories and Trades',
    fr: 'Poseur, Poseuse (toutes catégories) (tous les métiers)',
  },
  607: {en: 'Mail Clerk', fr: 'Postier, Postière'},
  608: {en: 'Orderly', fr: 'Préposé, Préposée aux bénéficiaires'},
  609: {en: 'Pawnbroker', fr: 'Prêteur, Prêteuse sur gages'},
  610: {en: 'Priest', fr: 'Prêtre, Prêtresse'},
  611: {en: 'Film Producer', fr: 'Producteur, Productrice cinéma'},
  612: {en: 'Video', fr: 'Producteur, Productrice vidéo'},
  613: {en: 'Theater Producer', fr: 'Producteur, Productrice de théâtre'},
  614: {en: 'Instructor – Fitness', fr: 'Professeur, Professeure conditionnement physique'},
  615: {en: 'Instructor – Trade', fr: 'Conditionnement métier'},
  616: {en: 'Instructor – Horseback Riding', fr: 'Conditionnement équitation'},
  617: {
    en: 'Instructor – Martial Arts, Combat Sports',
    fr: 'Professeur, Professeure arts martiaux, sports de combat',
  },
  618: {en: 'Instructor – Other', fr: 'Professeur, Professeure autres'},
  619: {en: 'Computer Programmer', fr: 'Programmeur, Programmeuse en informatique'},
  620: {en: 'Projectionist', fr: 'Projectionniste'},
  621: {en: 'Owner – Summer Camp', fr: 'Propriétaire camps de vacances'},
  622: {en: 'Owner – Golf Club', fr: 'Propriétaire club de golf'},
  623: {
    en: 'Owner – Taxi Fleet (Administrative or Supervisory Work Only)',
    fr: 'Propriétaire flotte de taxis (travail administratif ou de supervision seulement)',
  },
  624: {
    en: 'Owner–Operator – Farm (Administrative or Supervisory Work Only)',
    fr: 'Propriétaire exploitant agricole avec travail administratif ou de supervision seulement',
  },
  625: {en: 'Owner – Magazine', fr: 'Propriétaire revue'},
  626: {en: 'Owner – Theatre', fr: 'Propriétaire théâtre'},
  627: {en: 'Owner – Movie Theatre', fr: 'Propriétaire cinéma'},
  628: {en: 'Owner – Newspaper', fr: 'Propriétaire journal'},
  629: {en: 'Owner – Radio Station', fr: 'Propriétaire station de radio'},
  630: {en: 'Owner – Television', fr: 'Propriétaire de télévision'},
  631: {
    en: 'Owner – Livestock (Administrative Work Only)',
    fr: 'Propriétaire éleveur de bétail (travail administratif seulement)',
  },
  632: {en: 'Owner – Bowling Alley', fr: 'Propriétaire salon de quilles'},
  633: {en: 'Owner – Horseback Riding School', fr: "Propriétaire école d'équitation"},
  634: {en: 'Owner – Pool Hall', fr: 'Propriétaire salle de billard'},
  635: {en: 'Owner – Curling Rink (Management Only)', fr: 'Propriétaire de curling (gérance seulement)'},
  636: {
    en: 'Owner – Licensed Beverage Establishment Not Serving At The Bar (Except a Strip Club)',
    fr: 'Propriétaire débit de boissons ne servant pas au bar (sauf bar de danseurs ou danseuses nu(e)s)',
  },
  637: {en: 'Owner – Lodge', fr: 'Propriétaire gîte'},
  638: {en: 'Owner – Bed & Breakfast (B&B)', fr: 'Propriétaire Bed & Breakfast (B&B)'},
  639: {
    en: 'Owner –   Farm Operator (With Manual Labour)',
    fr: 'Propriétaire exploitant agricole avec travail manuel',
  },
  640: {
    en: 'Owner – Livestock (Supervision Only)',
    fr: 'Propriétaire éleveur de bétail (supervision seulement)',
  },
  641: {
    en: 'Owner – Livestock (With Manual Labour)',
    fr: 'Propriétaire éleveur de bétail avec travail manuel',
  },
  642: {
    en: 'Owner and Driver – Taxi Fleet(Drives Less Than 50% of the Time)',
    fr: 'Propriétaire flotte de taxis et chauffeur de taxi moins de 50 % du temps',
  },
  643: {
    en: 'Owner and Driver – Taxi Fleet (Drives 50% of the Time or More)',
    fr: 'Propriétaire flotte de taxis et chauffeur de taxi 50 % du temps et plus',
  },
  644: {en: 'Owner – Arcade and Video Games', fr: 'Propriétaire Arcade ou Jeux vidéo'},
  645: {
    en: 'Owner – Other (Administrative or Supervisory Work Only)',
    fr: 'Propriétaire autres (travail administratif ou supervision seulement)',
  },
  646: {en: 'Psychiatrist', fr: 'Psychiatre'},
  647: {en: 'Psychoeducator', fr: 'Psychoéducateur, Psychoéducatrice'},
  648: {en: 'Psychologist', fr: 'Psychologue'},
  649: {en: 'Psychotherapist', fr: 'Psychothérapeute'},
  650: {en: 'Radiologist', fr: 'Radiologiste, Radiologue'},
  651: {en: 'Furniture Collector', fr: 'Ramasseur, Ramasseuse de meubles'},
  652: {en: 'Chimney Cleaner', fr: 'Ramoneur, Ramoneuse'},
  653: {en: 'Producer', fr: 'Réalisateur, Réalisatrice'},
  654: {en: 'Tire Retreader', fr: 'Rechapeur, Rechapeure de pneu'},
  655: {en: 'Researcher', fr: 'Recherchiste'},
  656: {en: 'Recreologist', fr: 'Récréologue'},
  657: {en: 'Editor', fr: 'Rédacteur, Rédactrice'},
  658: {en: 'Reflexologist', fr: 'Réflexologie'},
  659: {en: 'Director/Manager', fr: 'Régisseur, Régisseuse'},
  660: {en: 'Public Relations Officer', fr: 'Relationniste'},
  661: {en: 'Binder', fr: 'Relieur, Relieuse'},
  662: {en: 'Upholsterer', fr: 'Rembourreur, Rembourreuse de meubles'},
  663: {
    en: 'Jewelry Repairer – Hand Tools Only',
    fr: "Réparateur, Réparatrice de bijoux (se servant d'outils à main seulement)",
  },
  664: {
    en: 'Indoor Telephone Line Repairer',
    fr: "Réparateur, Réparatrice lignes téléphoniques à l'intérieur",
  },
  665: {en: 'HVAC Repairer', fr: 'Réparateur, Réparatrice système de chauffage ou de climatisation'},
  666: {
    en: 'Outside Telephone Line Repairer',
    fr: "Réparateur, Réparatrice lignes téléphoniques à l'extérieur",
  },
  667: {
    en: 'Jewelry Repairer – With Machinery',
    fr: 'Réparateur, Réparatrice de bijoux (utilisant de la machinerie)',
  },
  668: {en: 'Elevator Repairer', fr: 'Réparateur, Réparatrice ascenseur'},
  669: {en: 'High Voltage Line Repairer', fr: 'Réparateur, Réparatrice lignes à haute tension'},
  670: {en: 'Dispatcher', fr: 'Répartiteur, Répartritrice'},
  671: {
    en: 'Representative – Without Samples or With Samples Under 20 lbs',
    fr: 'Représentant, Représentante, Agent, Agente sans échantillons ou portant échantillons de 20 livres ou moins',
  },
  672: {
    en: 'Representative – With Samples Over 20 lbs',
    fr: 'Représentant, Représentante, Agent, Agente portant échantillons de plus de 20 livres',
  },
  673: {
    en: 'Family Type Resources or Intermediate Resources for Seniors',
    fr: 'Ressources de type familial ou intermédiaire pour personnes âgées',
  },
  674: {
    en: 'Family Type Resources or Intermediate Resources for People with Disabilities',
    fr: 'Ressources de type familial ou intermédiaire pour personnes handicapées',
  },
  675: {
    en: 'Family Type Resources or Intermediate Resources for Orphans',
    fr: 'Ressources de type familiales ou intermédiaire pour personnes orphelines',
  },
  676: {en: 'Chef – Restaurant', fr: 'Restaurant, chef cuisinier, cuisinière'},
  677: {en: 'Fine Art Restorer', fr: "Restaurateur, Restauratrice d'œuvres d'art"},
  678: {en: 'Editor', fr: 'Réviseur, Réviseure, Réviseuse'},
  679: {
    en: 'Midwife with Nursing Diploma or Equivalent',
    fr: "Sage–femme, Sage–homme avec diplôme d'infirmière ou titre équivalent",
  },
  680: {en: 'Lifeguard – Pool or Beach', fr: 'Sauveteur, Sauveteuse piscine ou plage'},
  681: {en: 'Lifeguard – Beach', fr: 'Sauveteur, Sauveteuse plage, secouriste'},
  682: {en: 'Screenwriter', fr: 'Scénariste'},
  683: {en: 'Scriptwriter', fr: 'Scripteur, Scriptrice'},
  684: {en: 'Sculptor', fr: 'Sculpteur, Scupltrice'},
  685: {en: 'Secretary', fr: 'Secrétaire'},
  686: {en: 'Locksmith', fr: 'Serrurier, Serrurière'},
  687: {
    en: 'Waiter/Waitress/Busboy/Busgirl – Restaurant',
    fr: 'Serveur, Serveuse, garçon de table restaurant',
  },
  688: {en: 'Server – Strip Club', fr: 'Serveur, serveuse bar de danseurs nus ou danseuses nues'},
  689: {en: 'Server – Other', fr: 'Serveur, serveuse autres'},
  690: {en: 'Sexologist', fr: 'Sexologue'},
  691: {en: 'Diver', fr: 'Scaphandrier, Scaphandrière'},
  692: {en: 'Diver Assistant', fr: 'Aide–scaphandrier, scaphandrière'},
  693: {en: 'Flagger – Road Traffic', fr: 'Signaleur routier, Signaleuse routière'},
  694: {en: 'Signalman – Rail', fr: 'Signaleur, Signaleuse train'},
  695: {en: 'Signalman – Air Transport', fr: 'Signaleur, Signaleuse avion'},
  696: {en: 'Welder', fr: 'Soudeur, Soudeuse'},
  697: {en: 'Switchboard Operator', fr: 'Standardiste'},
  698: {en: 'Stenographer', fr: 'Sténographe'},
  699: {
    en: 'Superintendent – Municipal Park (Monitoring Only)',
    fr: 'Surintendant, Surintendante parc municipal avec surveillance seulement',
  },
  700: {
    en: 'Superintendent – Underground Mine with Less Than 10% Underground Work and Open–Air Mine',
    fr: 'Surintendant, Surintendante mines souterraines (allant sous terre moins de 10 %), mines à ciel ouvert',
  },
  701: {en: 'Superintendent – Explosives Factory', fr: "Surintendant, Surintendante manufacture d'explosifs"},
  702: {
    en: 'Superintendent – Underground Mine with 10% or More Underground Work',
    fr: 'Surintendant, Surintendante mines souterraines (allant sous terre 10 % et plus)',
  },
  703: {en: 'Superintendent – Other', fr: 'Surintendant, Surintendante autres'},
  704: {en: 'Marine Port Supervisor', fr: 'Surveillant, Surveillante port maritime'},
  705: {en: 'Marina Supervisor', fr: 'Surveillant, Surveillante marina'},
  706: {en: 'Pool Lifeguard', fr: 'Surveillant, Surveillante piscine'},
  707: {en: 'Beach Lifeguard', fr: 'Surveillant, Surveillante plage'},
  708: {en: 'Supervisor – Other (Office Only)', fr: 'Surveillant, Surveillante autres – bureau seulement'},
  709: {
    en: 'Supervisor – Other (In the Field)',
    fr: 'Surveillant, Surveillante autres –  allant sur le terrain',
  },
  710: {
    en: 'Jewelry Adjuster –  Hand Tools Only',
    fr: "Tailleur, Tailleuse bijoux se servant d'outils à mains seulement",
  },
  711: {en: 'Jewelry Adjuster – With Machinery', fr: 'Tailleur, Tailleuse bijoux utilisant de la machinerie'},
  712: {en: 'Clothing Tailor', fr: 'Tailleur, Tailleuse vêtement'},
  713: {en: 'Carpet Maker', fr: 'Tapissier, Tapissière'},
  714: {
    en: 'Tattoo Shop Owner and Artist – At Least 2 Years of Experience and Operating Outside the Home',
    fr: "Tatoueur, Tatoueuse propriétaire depuis au moins 2 ans et à l'extérieur du domicile",
  },
  715: {en: 'Tattoo Artist – Other', fr: 'Tatoueur, Tatoueuse autres'},
  716: {en: 'Taxidermist', fr: 'Taxidermiste'},
  717: {en: 'Technician – Land Survey', fr: 'Technicien arpenteur, Technicienne arpenteuse'},
  718: {
    en: 'Technician – Architectural (Not in the Field)',
    fr: 'Technicien, Technicienne architecture (pas sur les chantiers)',
  },
  719: {
    en: 'Technician – Special Education (Office Only)',
    fr: 'Technicien, Technicienne éducation spécialisée (bureau seulement)',
  },
  720: {en: 'Technician – Rehabilitation', fr: 'Technicien, Technicienne réadaptation'},
  721: {en: 'Technician – Dental', fr: 'Technicien, Technicienne dentaire'},
  722: {
    en: 'Technician – Architectural (In the Field)',
    fr: 'Technicien, Technicienne architecture (sur les chantiers)',
  },
  723: {
    en: 'Technician – Special Education (In the Field)',
    fr: 'Technicien, Technicienne éducation spécialisée (sur le terrain)',
  },
  724: {en: 'Technician – Electronic', fr: 'Technicien, Technicienne électronique'},
  725: {en: 'Technician – Civil Engineering', fr: 'Technicien, Technicienne génie civil'},
  726: {en: 'Technician – Computer', fr: 'Technicien, Technicienne informatique'},
  727: {
    en: 'Technician – Laboratory With No Exposure to Nuclear Radiation',
    fr: 'Technicien, Technicienne laboratoire (non exposé aux émanations nucléaires)',
  },
  728: {en: 'Technician – Radiology', fr: 'Technicien, Technicienne radiologie'},
  729: {en: 'Technician – Electrolysis', fr: 'Technicien, Technicienne électrolyse'},
  730: {en: 'Technician – Contact Lens', fr: 'Technicien, Technicienne fabrication de lentilles cornéennes'},
  731: {
    en: 'Technician – Animal Insemination (In Laboratory)',
    fr: 'Technicien, Technicienne insémination animale (en laboratoire)',
  },
  732: {en: 'Technician – High-Voltage Power Line', fr: 'Technicien, Technicienne lignes à haute tension'},
  733: {
    en: 'Technician – Laboratory With Exposure to Nuclear Radiation',
    fr: 'Technicien, Technicienne laboratoire (exposé aux émanations nucléaires)',
  },
  734: {en: 'Dyer', fr: 'Teinturier, Teinturière'},
  735: {en: 'Telephone Operator', fr: 'Téléphoniste'},
  736: {en: 'Thanatologist', fr: 'Thanatologue'},
  737: {en: 'Drywall Finisher', fr: 'Tireur, Tireuse de joints'},
  738: {en: 'Groomer', fr: 'Toiletteur, Toiletteuse'},
  739: {en: 'Sheet Metal Worker – Workshop Only', fr: 'Tôlier, Tôlière en atelier seulement'},
  740: {en: 'Sheet Metal Worker – Outside the Workshop', fr: "Tôlier, Tôlière extérieure d'atelier"},
  741: {en: 'Certified Translator', fr: 'Traducteur, Traductrice agréé'},
  742: {en: 'Non-Certified Translator', fr: 'Traducteur, Traductrice non agréé'},
  743: {
    en: 'Caterer – Administrative or Supervisory Work Only',
    fr: 'Traiteur, Traiteuse travail administratif ou supervision seulement',
  },
  744: {en: 'Caterer – Other', fr: 'Traiteur, Traiteuse autres'},
  745: {en: 'Trapper', fr: 'Trappeur'},
  746: {en: 'Social Worker – Office Only', fr: 'Travailleur, Travailleuse sociale au bureau seulement'},
  747: {en: 'Social Worker – In the Field', fr: 'Travailleur, Travailleuse sociale sur le terrain'},
  748: {en: 'Pipe Fitter', fr: 'Tuyauteur, Tuyauteuse'},
  749: {en: 'Typographer', fr: 'Typographe'},
  750: {en: 'Urban Planner', fr: 'Urbaniste'},
  751: {en: 'Valet', fr: 'Valet'},
  752: {en: 'Seller – Plumbing', fr: 'Vendeur, Vendeuse plomberie'},
  753: {en: 'Seller – Furniture', fr: 'Vendeur, Vendeuse meuble'},
  754: {en: 'Seller – Auto Parts', fr: "Vendeur, Vendeuse pièce d'autos"},
  755: {en: 'Seller – Flooring', fr: 'Vendeur, Vendeuse revêtements de plancher'},
  756: {
    en: 'Seller – Other (No Merchandise Handling or Physical Labour)',
    fr: 'Vendeur, Vendeuse autres sans manipulation de marchandises, ni travail physique',
  },
  757: {en: 'Seller – Other', fr: 'Vendeur, Vendeuse autres'},
  758: {en: 'Auditor', fr: 'Vérificateur, Vérificatrice'},
  759: {en: 'Varnisher', fr: 'Vernisseur, Vernisseuse'},
  760: {en: 'Small Animal Veterinarian', fr: 'Vétérinaire petit animal'},
  761: {en: 'Farm Animal Veterinarian', fr: 'Vétérinaire animal de fermes'},
  762: {en: 'Window Installer and Repairer', fr: 'Vitrier, Vitrière'},
  763: {en: 'Zoologist', fr: 'Zoologiste'},
  764: {en: 'Pool Installer', fr: 'Installateur, Installatrice de piscine'},
  765: {en: 'Executive Assistant', fr: 'Adjoint de direction, Adjointe de direction'},
  766: {en: 'Administrative Support Agent', fr: 'Agent, Agente soutien administratif'},
  767: {en: 'Customer Service Agent', fr: 'Agent, Agente,  de service à la clientèle'},
  768: {
    en: 'Home Child Care Educator Assistant - Licensed',
    fr: 'Aide-éducateur, Aide-éducatrice garderie avec certification à domicile',
  },
  769: {
    en: 'Prosthetist Assistant/Orthopedic Accessory Adjuster/Surgical Device Adjuster',
    fr: "Aide-prothésiste, ajusteur/ajusteuse d'accessoires orthopédiques, ajusteur/ajusteuse d'appareils chirurgicaux",
  },
  770: {en: 'Crowd Animator', fr: 'Animateur, Animatrice de foule'},
  771: {en: 'Apparitor', fr: 'Appariteur, Appariteuse'},
  772: {en: 'Auto Body Person', fr: 'Carrossier, Carrosière, Débosseleur, Débosseleuse'},
  774: {en: 'Cement Maker and Applicator', fr: 'Cimentier, Cimentière, Applicateur , Applicatrice'},
  775: {
    en: 'Human Resources Advisor/Talent Recruiter',
    fr: 'Conseiller, Conseillière en ressources humaines, recruteur, recruteuse de talent, Dotation',
  },
  776: {
    en: 'Human Resources Associate',
    fr: 'Généraliste ressources humaines, partenaire ressources humaines',
  },
  777: {en: 'Museum Curator', fr: 'Conservateur, Conservatrice musée'},
  778: {en: 'Controller - Road', fr: 'Contrôleur, Contrôleuse routier'},
  779: {en: 'Rope Access Technician', fr: 'Cordiste'},
  782: {en: 'Snow Removal Worker', fr: 'Déneigeur, Déneigeuse'},
  783: {
    en: 'Home Child Care Educator Licenced',
    fr: 'Éducateur, Éducatrice garderie autorisée à domicile avec certificat',
  },
  785: {en: 'Real Estate Appraiser', fr: 'Évaluateur, Évaluatrice immobilier'},
  788: {en: 'Naval Forces (see exclusions)', fr: 'Forces navales (voir exclusions)'},
  789: {en: 'Clerk', fr: 'Greffier, Greffière'},
  790: {en: 'Importer/Exporter', fr: 'Importateur, Importatrice, Exportateur, Exportatrice'},
  791: {
    en: 'Instructor - Scuba Diving',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice plongée sous-marine',
  },
  792: {en: 'Instructor - Ski', fr: 'Instructeur, Instructrice, Moniteur, Monitrice ski'},
  793: {
    en: 'Instructor - Aviation/Flight Monitor',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice de vol, aviation',
  },
  794: {
    en: 'Instructor - Paragliding',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice de vol, parapente',
  },
  795: {en: 'Instructor - Parachute', fr: 'Instructeur, Instructrice, Moniteur, Monitrice de parachute'},
  796: {en: 'Wrestler', fr: 'Lutteur, Lutteuse'},
  797: {en: 'Mathamatician', fr: 'Mathématicien, Mathématicienne'},
  798: {en: 'Opthamologist', fr: 'Ophtalmologiste, Ophtalmologue'},
  800: {en: 'Toll Attendant', fr: 'Péagiste'},
  801: {en: 'Presser', fr: 'Presseur, Presseuse'},
  802: {en: 'Radio or Television Producer', fr: 'Producteur, Productrice radio ou télévision'},
  803: {en: 'Assistant Film Producer', fr: 'Assistant producteur, Assistante productrice cinéma'},
  804: {en: 'Assistant Film Video Producer', fr: 'Assistant producteur, Assistante productrice vidéo'},
  805: {
    en: 'Assistant Film Radio or Television Producer',
    fr: 'Assistant producteur, Assistante productrice radio ou télévision',
  },
  806: {en: 'Assistant Theater Producer', fr: 'Assistant producteur, Assistante productrice théatre'},
  809: {en: 'Owner - Bowling Alley', fr: 'Propriétaire salle de bowling'},
  810: {
    en: 'Owner - Other (Administrative and Manual)',
    fr: 'Propriétaire autres (travail manuel et administratif)',
  },
  811: {en: 'Receptionist', fr: 'Réceptionniste'},
  812: {en: 'Religious', fr: 'Religieux, Religieuse'},
  813: {en: 'Repairer - Other', fr: 'Réparateur, Réparatrice autres'},
  814: {en: 'Rodeo', fr: 'Rodéo'},
  815: {en: 'Stylist', fr: 'Styliste'},
  816: {en: 'Emergency Physician', fr: 'Urgentologue, Urgentiste'},
  817: {
    en: 'Instructor - Football, Hockey',
    fr: 'Instructeur, Instructrice, Moniteur, Monitrice football, hockey',
  },
  818: {
    en: 'Unemployed',
    fr: 'Sans emploi',
  },
  819: {
    en: 'Student',
    fr: 'Étudiant',
  },
};
